import React, { PureComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/cosmos';
import { Input } from 'components/input';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import EmbedMediaModal from './EmbedMediaModal';

export default class InputEmbedMediaFilled extends PureComponent {
  static propTypes = {
    checkEmbedUrl: PropTypes.func,
    mediaUrl: PropTypes.string,
    setMediaUrl: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      inputValue: props.mediaUrl,
      showModal: false
    };
  }

  setMediaValue = (inputValue) => {
    this.setState({ inputValue });
  };

  toggleShowModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal
    }));
  };

  componentDidUpdate(prevProps) {
    if (prevProps.mediaUrl !== this.props.mediaUrl) {
      this.setMediaValue(this.props.mediaUrl);
    }
  }

  handleMediaUrl = (mediaUrl = null) => {
    const { setMediaUrl } = this.props;

    setMediaUrl(mediaUrl);
  };

  render() {
    const { mediaUrl, checkEmbedUrl } = this.props;
    const { inputValue, showModal } = this.state;

    return (
      <>
        <div className="media__header__wrapper">
          <Button
            variation="tertiary"
            onClick={this.toggleShowModal}
            className="_d-flex _align-items-center _gap-2"
          >
            <FontAwesomeIcon icon={['fal', 'trash']} />
            <I18n label="general.remove" />
          </Button>
        </div>
        <div className="media__embed__wrapper">
          <div className="media__embed">
            <iframe
              width="560"
              height="315"
              src={mediaUrl}
              frameBorder="0"
              allowFullScreen
              key={mediaUrl}
            />
          </div>
          <div className="media__input">
            <div className="embed__link">
              <Input
                value={inputValue}
                onChange={(e) => this.setMediaValue(e.target.value)}
                type="text"
                name="media__url"
                className="media__url"
                placeholder="embed.link.placeholder"
              />
              <button
                className="hot-button hot-button--secondary _mt-2"
                onClick={() => checkEmbedUrl(inputValue)}
              >
                <I18n label="embed.change" />
              </button>
            </div>
          </div>
        </div>

        {showModal && (
          <EmbedMediaModal
            setMediaUrl={this.handleMediaUrl}
            toggleModal={this.toggleShowModal}
          />
        )}
      </>
    );
  }
}
